import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
type CarouselProps = {
  children: React.ReactNode;
  label: string;
  itemClassName?: string;
};
export function Carousel({
  children,
  label,
  itemClassName = ''
}: CarouselProps) {
  const trackRef = useRef<HTMLDivElement>(null);
  const scrollBy = (direction: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    track.scrollBy({
      left: direction * Math.round(track.clientWidth * 0.8),
      behavior: 'smooth'
    });
  };
  const items = React.Children.toArray(children);
  return <div className="relative" data-id="element-202" data-mp="220flqf1fyqp">
      <div ref={trackRef} role="group" aria-label={label} className="no-scrollbar flex snap-x snap-mandatory gap-5 overflow-x-auto scroll-smooth pb-2" data-id="element-203" data-mp="21qm3susb9g9">
        {items.map((child, index) => <div key={index} className={`shrink-0 snap-center ${itemClassName}`} data-id="element-204" data-mp="35i7frmy8vduq" data-mpi={index}>
            {child}
          </div>)}
      </div>

      <div className="mt-6 flex items-center justify-center gap-3" data-id="element-205" data-mp="1f8pn2cnbuv60">
        <button type="button" onClick={() => scrollBy(-1)} aria-label={`Anterior — ${label}`} className="flex h-11 w-11 items-center justify-center rounded-full border border-night-line bg-night-card text-gold transition-colors duration-150 ease-out hover:border-gold hover:text-gold-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-206" data-mp="1f7xr30ptivf7">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-207" data-mp="rilnqhh69hkt" />
        </button>
        <button type="button" onClick={() => scrollBy(1)} aria-label={`Siguiente — ${label}`} className="flex h-11 w-11 items-center justify-center rounded-full border border-night-line bg-night-card text-gold transition-colors duration-150 ease-out hover:border-gold hover:text-gold-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-208" data-mp="mk1vy0fwdbkj">
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-209" data-mp="a90xy27sph7z" />
        </button>
      </div>
    </div>;
}